/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllResidentsResponse } from './FindAllResidentsResponse';
import {
    FindAllResidentsResponseFromJSON,
    FindAllResidentsResponseFromJSONTyped,
    FindAllResidentsResponseToJSON,
    FindAllResidentsResponseToJSONTyped,
} from './FindAllResidentsResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerResidents200Response
 */
export interface FindAllScreenerResidents200Response {
    /**
     * 
     */
    data?: FindAllResidentsResponse;
}

/**
 * Check if a given object implements the FindAllScreenerResidents200Response interface.
 */
export function instanceOfFindAllScreenerResidents200Response(value: object): value is FindAllScreenerResidents200Response {
    return true;
}

export function FindAllScreenerResidents200ResponseFromJSON(json: any): FindAllScreenerResidents200Response {
    return FindAllScreenerResidents200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerResidents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerResidents200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllResidentsResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerResidents200ResponseToJSON(json: any): FindAllScreenerResidents200Response {
    return FindAllScreenerResidents200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerResidents200ResponseToJSONTyped(value?: FindAllScreenerResidents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllResidentsResponseToJSON(value['data']),
    };
}

